import { markCandidateAsPhoned, markCandidateAsEmailed } from '../api/SlmService';

export const markCandidateAsContacted = (candidateId, contactType) => {
  const apiCall = contactType === 'email' ? markCandidateAsEmailed : markCandidateAsPhoned;
  apiCall(candidateId).catch((error) => {
    console.error(`Error marking candidate as contacted via ${contactType}`, error);
  });
};
